"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CalloutExample = void 0;
var tslib_1 = require("tslib");
var mithril_1 = tslib_1.__importDefault(require("mithril"));
var _1 = require("@/");
var examples_1 = require("@shared/examples");
var EXAMPLE_SRC = 'components/callout/examples/index.ts';
var content = 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla rhoncus tempor neque, sed malesuada eros dapibus vel. Aliquam in ligula vitae tortor porttitor laoreet iaculis finibus est.';
var CalloutExample = /** @class */ (function () {
    function CalloutExample() {
        this.showIcon = true;
        this.showHeader = true;
        this.showContent = true;
        this.dismissable = true;
    }
    CalloutExample.prototype.view = function () {
        return (0, mithril_1.default)(examples_1.Example, { options: this.renderOptions(), src: EXAMPLE_SRC }, [
            (0, mithril_1.default)(_1.Callout, {
                header: this.showHeader && 'Callout header',
                content: this.showContent && content,
                icon: this.showIcon ? _1.Icons.ALERT_CIRCLE : undefined,
                size: this.size,
                intent: this.intent,
                onDismiss: this.dismissable ? function () { return null; } : undefined
            })
        ]);
    };
    CalloutExample.prototype.renderOptions = function () {
        var _this = this;
        return [
            (0, mithril_1.default)('h5', 'Size'),
            (0, mithril_1.default)(examples_1.SizeSelect, { onSelect: function (size) { return _this.size = size; } }),
            (0, mithril_1.default)('h5', 'Intent'),
            (0, mithril_1.default)(examples_1.IntentSelect, { onSelect: function (intent) { return _this.intent = intent; } }),
            (0, mithril_1.default)(_1.Switch, {
                checked: this.showIcon,
                label: 'Show icon',
                onchange: function () { return _this.showIcon = !_this.showIcon; }
            }),
            (0, mithril_1.default)(_1.Switch, {
                checked: this.showHeader,
                label: 'Show header',
                onchange: function () { return _this.showHeader = !_this.showHeader; }
            }),
            (0, mithril_1.default)(_1.Switch, {
                checked: this.showContent,
                label: 'Show content',
                onchange: function () { return _this.showContent = !_this.showContent; }
            }),
            (0, mithril_1.default)(_1.Switch, {
                checked: this.dismissable,
                label: 'Dismissable',
                onchange: function () { return _this.dismissable = !_this.dismissable; }
            })
        ];
    };
    return CalloutExample;
}());
exports.CalloutExample = CalloutExample;
